import React from "react";
import { CheckCircle2, Hourglass, MinusCircle, XCircle } from "lucide-react";

export const OUTCOME_STATUS_META = {
  correct: { label: "Correct", Icon: CheckCircle2 },
  wrong: { label: "Wrong", Icon: XCircle },
  void: { label: "Void", Icon: MinusCircle },
  pending: { label: "Pending", Icon: Hourglass },
};

const OutcomeStatusBadge = ({ status }) => {
  const meta = OUTCOME_STATUS_META[status];
  if (!meta) return null;
  const { label, Icon } = meta;
  return (
    <span className={`pred-outcome-status pred-outcome-status-${status}`}>
      <Icon size={10} />
      {label}
    </span>
  );
};

export default OutcomeStatusBadge;
